import { Suspense } from 'react';
import V2Root from './v2/V2Root';

const App = () => (
  <Suspense fallback={<div style={{ padding: 24, textAlign: 'center' }}>Đang tải…</div>}>
    <V2Root />
  </Suspense>
);

export default App;
